import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconDocumentExportOutline } from '@icons/IconDocumentExportOutline'
import { FormData } from './types'
import { isEmptyObject } from '../StatementEditorComponent/types-v6'
import { exportToExcel } from '../DataTableComponent/utils/exportUtils'

const handleExport = async (formValues: FormData | Record<string, never>) => {
  const date = new Date().toLocaleDateString()
  const fileName = `data-form-export - ${date}.xlsx`
  await exportToExcel([formValues], fileName)
}

export function ExportAction({ formValues }: { formValues: FormData }) {
  if (isEmptyObject(formValues)) {
    return null
  }
  return (
    <TooltipButton tooltip={'Export to Excel'}>
      <Button size="icon" variant="ghost" className="size-8 rounded-full" onClick={() => handleExport(formValues)}>
        <IconDocumentExportOutline className="size-4" />
      </Button>
    </TooltipButton>
  )
}
